export const MAX_MSG_PER_CHANNEL = 20;

export const MAX_CHANNELS_PER_PAGE = 15;

export const UNKNOWN_VALUE = 'Unknown';

export const MESSAGE_NOTIFICATION = 'Notification';
